import React, { useEffect, useRef } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';

// Lightweight Rich Text Editor using contentEditable and document.execCommand
// Returns/accepts HTML string in value
const RichTextEditor = ({ value, onChange, placeholder = "Write content..." }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    if (editorRef.current && value !== editorRef.current.innerHTML) {
      editorRef.current.innerHTML = value || '';
    }
  }, [value]);

  const handleCommand = (cmd, arg = null) => {
    document.execCommand(cmd, false, arg);
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  const handleInput = () => {
    if (editorRef.current) {
      onChange(editorRef.current.innerHTML);
    }
  };

  return (
    <div>
      <ButtonGroup className="mb-2 flex-wrap">
        <Button size="sm" variant="outline-secondary" onClick={() => handleCommand('bold')}><strong>B</strong></Button>
        <Button size="sm" variant="outline-secondary" onClick={() => handleCommand('italic')}><em>I</em></Button>
        <Button size="sm" variant="outline-secondary" onClick={() => handleCommand('underline')}><u>U</u></Button>
        <Button size="sm" variant="outline-secondary" onClick={() => handleCommand('insertUnorderedList')}>• List</Button>
        <Button size="sm" variant="outline-secondary" onClick={() => handleCommand('insertOrderedList')}>1. List</Button>
        <Button size="sm" variant="outline-secondary" onClick={() => handleCommand('formatBlock', '<h3>')}>H3</Button>
        <Button size="sm" variant="outline-secondary" onClick={() => handleCommand('formatBlock', '<p>')}>P</Button>
        <Button size="sm" variant="outline-secondary" onClick={() => handleCommand('justifyLeft')}>Left</Button>
        <Button size="sm" variant="outline-secondary" onClick={() => handleCommand('justifyCenter')}>Center</Button>
        <Button size="sm" variant="outline-secondary" onClick={() => handleCommand('justifyRight')}>Right</Button>
        <Button size="sm" variant="outline-secondary" onClick={() => {
          const url = prompt('Enter link URL');
          if (url) handleCommand('createLink', url);
        }}>Link</Button>
        <Button size="sm" variant="outline-secondary" onClick={() => handleCommand('removeFormat')}>Clear</Button>
      </ButtonGroup>

      <div
        ref={editorRef}
        className="form-control"
        style={{ minHeight: 200, overflowY: 'auto' }}
        contentEditable
        onInput={handleInput}
        onBlur={handleInput}
        data-placeholder={placeholder}
      />
    </div>
  );
};

export default RichTextEditor;


